<template>
  <div :data-view-id="componentUniqueTitle || uniqueTitle" class="richtext-view">
    <ViewTitle :title="title" />
    <div v-if="safeHtml" class="richtext-view-content" v-html="safeHtml"></div>
    <div v-else class="richtext-view-empty">
      <p>No content</p>
    </div>
  </div>
</template>

<script>
import ViewTitle from './ViewTitle.vue'
import { sanitizeHtml } from '../../../shared/html-sanitize'

export default {
  name: 'RichTextView',
  components: {
    ViewTitle
  },
  props: {
    uniqueTitle: { type: String, default: '' },
    title: { type: String, default: '' },
    richTextContent: { type: String, default: '' },
    componentUniqueTitle: { type: String, default: '' },
    pageUniqueTitle: { type: String, default: '' }
  },
  computed: {
    safeHtml () {
      return sanitizeHtml(this.richTextContent)
    }
  }
}
</script>

<style scoped>
.richtext-view {
  padding: 1rem;
}

.richtext-view-empty {
  color: #999;
  font-style: italic;
}
</style>

<style>
.richtext-view-content p {
  margin: 0 0 0.5em 0;
}

.richtext-view-content img.rich-text-image {
  max-width: 100%;
  height: auto;
  margin: 4px 0;
}

.richtext-view-content pre {
  padding: 12px;
  margin: 8px 0;
  overflow-x: auto;
}

.richtext-view-content pre code {
  font-family: monospace;
  font-size: 13px;
  padding: 0;
}

.richtext-view-content code {
  padding: 1px 4px;
  font-family: monospace;
  font-size: 13px;
}

.richtext-view-content a {
  color: #0d6efd;
  text-decoration: underline;
}

.richtext-view-content blockquote {
  border-left: 3px solid #dee2e6;
  padding-left: 12px;
  margin-left: 0;
  color: #6c757d;
}
</style>
